// DS1.7.3
import React from 'react';
import classnames from 'classnames';
import MultiImage from '../../Icons/16x16/MultiImage';
import { IconSize } from '../../Icons/IconWrap';
import s from './MediaIndicator.scss';
function formatDuration(duration = 0) {
    if (!duration) {
        return null;
    }
    const seconds = duration % 60;
    const minutes = (duration - seconds) / 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}
const MediaIndicator = ({ type, duration, isMultiImage, className })=>{
    if (!isMultiImage && !type) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, isMultiImage ? /*#__PURE__*/ React.createElement(MultiImage, {
        disableDefaultColors: true,
        "aria-label": "stack of images",
        size: IconSize.SMALLER
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, type === 'gif' && 'GIF', type === 'video' && formatDuration(duration), type === 'hd' && 'HD'));
};
MediaIndicator.displayName = 'MediaIndicator';
export default MediaIndicator;

//# sourceMappingURL=MediaIndicator.js.map